import { configureApiErrorHandler } from 'lib/Helper/Auth';
import ReactDOM from 'react-dom';
import App from './App';

configureApiErrorHandler();

ReactDOM.render(<App />, document.getElementById('root'));
